import cx from 'classnames';
import CustomSelect from '../../../CustomSelect/CustomSelect';
import FormField from '../../../form-field/FormField';
import { IRangeDates } from '../../../month-range-picker-with-options/model/types/IRangeDates';
import { useFilterPanelContext } from '../../context/FilterPanelContext';
import filterPanelStyles from '../../FilterPanel.module.scss';
import { FilterField, FilterFieldOptions } from '../../types';
import { CSSProperties } from 'react';
import { AppSelect } from '@fsd/shared/ui/AppSelect';

interface IProps {
  field: FilterField;
  style?: CSSProperties;
}

const SelectField = ({ field, style }: IProps) => {
  const { values, setValues, setAutocomplete } = useFilterPanelContext();

  const customSelectOptions = (field.options || []).map((opt) => ({
    id: opt?.value || '',
    name: opt?.label || '',
    value: opt?.value || '',
  }));

  const options = (field.options ?? []).filter(
    (option): option is FilterFieldOptions => option !== undefined
  );

  const handleChange = (value: string | number | boolean) => {
    setValues({ ...values, [field.key]: value });
    setAutocomplete((prev) => ({
      ...prev,
      [field.key]: String(value),
    }));
  };

  return (
    <div
      key={field.key}
      className={cx(filterPanelStyles.filterItem, field.className)}
      tabIndex={0}
      style={style}
    >
      <FormField label={field.label}>
        <AppSelect
          options={options}
          value={values[field.key] as string | number | boolean | undefined}
          onChange={handleChange}
          placeholder={field.placeholder ?? 'Выбрать'}
          disabled={field.disabled}
        />
      </FormField>
    </div>
  );
};

export default SelectField;
